import React from 'react';

const AuthenticationContext = React.createContext({});

export default AuthenticationContext;
